export const OrgForms = {
  Dashboard: 1,
  Branch: 2,
  Users: 3,
  Clients: 4,
  Appointments: 5,
  Services: 6,
  WebsiteBuilder: 7,
  Messaging: 8,
  FollowUps: 9,
  Inquiries: 10,
} as const;

export type OrgForm = (typeof OrgForms)[keyof typeof OrgForms];
